import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// PARTS
import Table from 'parts/table/Table';

// MAIN COMPONENT
const EstimatedDelivery = ({
  row: { original: { estimated_delivery_date_expired } } = {}, //
  value,
  ...props
}) => (
  <Table.Date {...props} className={clsx(estimated_delivery_date_expired === 1 && 'text-danger')}>
    {value}
  </Table.Date>
);

// EXPORT
export default EstimatedDelivery;
